<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '420px' }"
    header="Fomulário de Registros"
    :modal="true"
    @hide="hideDialog"
  >
    <div class="p-fluid formgrid grid">
      <div class="field col-12">
        <label for="per">Período</label>
        <Calendar
          id="per"
          view="month"
          dateFormat="mm/yy"
          v-model="v$.registro.periodo.$model"
          placeholder="Digite o período"
          :class="{
            'p-invalid': submitted && v$.registro.periodo.$invalid,
          }"
        />
        <small v-if="submitted && v$.registro.periodo.$invalid" class="p-error"
          >Período é obrigatório.</small
        >
      </div>

      <div class="field col-12">
        <label for="vl">Valor</label>
        <InputNumber
          v-model="v$.registro.valor.$model"
          inputId="locale-BRL"
          locale="pt-BR"
          currency="BRL"
          :minFractionDigits="2"
          placeholder="Informe o valor"
          :class="{
            'p-invalid': submitted && v$.registro.valor.$invalid,
          }"
        />
        <small v-if="submitted && v$.registro.valor.$invalid" class="p-error"
          >Valor é obrigatório.</small
        >
      </div>

      <div class="field col-12">
        <label for="tp">Tipo</label>
        <Dropdown
          id="tp"
          v-model="v$.registro.tipo.$model"
          :options="allTipo"
          optionLabel="descricao"
          placeholder="Selecione o tipo"
          :class="{
            'p-invalid': submitted && v$.registro.tipo.id.$invalid,
          }"
        />
        <small v-if="submitted && v$.registro.tipo.id.$invalid" class="p-error"
          >Tipo é obrigatório.</small
        >
      </div>

      <div class="field col-12">
        <label for="desc">Setor</label>
        <Dropdown
          id="group"
          v-model="v$.registro.subUnidade.$model"
          :options="allSetor"
          optionLabel="descricao"
          placeholder="Selecione o setor"
          filter="true"
          :class="{
            'p-invalid': submitted && v$.registro.subUnidade.id.$invalid,
          }"
        />
        <small v-if="submitted && !registro.subUnidade.id" class="p-error"
          >Setor é obrigatório.</small
        >
      </div>
    </div>

    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.registro.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Registro from "../../../models/registro";

//Services
import RegistroService from "../../../service/registro/registroService";
import TipoService from "../../../service/tipo/tipoService";
import SubUnidadeService from "../../../service/subUnidade/subUnidadeService";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["selected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      allTipo: [],
      allSetor: [],
      registro: new Registro(),
      registroService: new RegistroService(),
      subUnidadeService: new SubUnidadeService(),
      tipoService: new TipoService(),
      submitted: false,
    };
  },
  validations() {
    return {
      registro: new Registro().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.registro.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.registro.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;

      this.registro.periodo =
        this.registro.periodo.length <= 7
          ? this.registro.periodo
          : (this.registro.periodo = this.$DateTime.formateMesAndAno(
              this.registro.periodo
            ));

      /*
      if (this.registro.periodo.length <= 7) {
        console.log("aki")
      } else {
        this.registro.periodo = this.$DateTime.formateMesAndAno(
          this.registro.periodo
        );
      }
        */

      //console.log(this.registro.periodo);

      if (isFormValid) {
        if (this.registro.id) {
          this.update();
        } else {
          this.create();
        }
      } else {
        return;
      }
    },
    create() {
      this.registroService
        .create(this.registro)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.registroService
        .update(this.registro)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.registro = new Registro();
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    getData() {
      this.registro = this.selected;
      this.findSetor();
      this.findTipo();
    },
    findSetor() {
      this.subUnidadeService.findAll().then((data) => {
        this.allSetor = data;
      });
    },
    findTipo() {
      this.tipoService.findAll().then((data) => {
        this.allTipo = data;
      });
    },
  },
};
</script>
<style scoped></style>
